export const validatorPositive = value => {
    if (value >= 0) {
        return true
    }
    return false
}

export const validatorNormalInteger = value => /^\+?[1-9]\d*$/.test(value)

export const validatorPassword = password => {
    const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!#$%&()*.@])/

    const validPassword = regExp.test(password)
    return validPassword
}

export const validatorCreditCard = creditnum => {
    const cRegExp = /^3[47]\d{13}$/

    const validCreditCard = cRegExp.test(creditnum)
    return validCreditCard
}

export const validatorUrlValidator = val => {
    if (val === undefined || val === null || val.length === 0) {
        return true
    }
    /* eslint-disable no-useless-escape */
    const re = /^(https?:\/\/){0,1}(www\.){0,1}[\d.A-Za-z\-]+\.[A-Za-z]{2,5}\.{0,1}/
    /* eslint-enable no-useless-escape */
    return re.test(val)
}

export const validatorCSV = value =>
    // ([\w\s\:\-\/]*)
    // return /^(\w+)|(\w(?=(,\s*\w+)))*$/.test(value);
    // /^([\w\s\:\-\/\.]+)(((,(?=\s*))(?:([\w\s\:\-\/\.]+)))*)$/.test(value)
    /^([\s\w./:-]+)(((,(?=\s*))([\s\w./:-]+))*)$/.test(value)

export const validate_Lote = val => /^V\d+$|^R\d+$|^\d+$/.test(val)

export const validate_distancia = dis => /^[1-9]\d*$/.test(dis)

export const validatorTemp = temp => Number(temp) >= -273.15

export const validatorAlphaNumSpaces = val => /^[\dA-Za-z][\w -]*$/.test(val)

export const validatorSecDae = val => /^(\d+)-(\d+)-(\d+)-(\d{1,8})$/g.test(val)
export const validate_viaje = val => /^[\dA-Za-z][\w/-]{0,9}$/.test(val)

export const validate_emails = val => /(?!.*;$)^([\w-.]+?@[\w-.]+\.\w+;?)+$/.test(val)

// export const validateEmptyArray = val => Array.isArray(val) && val.length > 0
export const validateEmptyArray = val => Array.isArray(val) && val.length > 0
